<template>
  <b-card>
    <layout-loading v-if="itemLoading" />
    <b-form v-if="render">
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('general.email')"
            label-for="subscription-email"
          >
            <b-form-input
              id="subscription-email"
              v-model="form.email"
              :state="validateState('email')"
            />
            <b-form-invalid
              id="input-subscription-feedback"
              :label="$t('general.email')"
              :validator="$v.form.email"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>
<script>
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
} from 'bootstrap-vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import { required, minLength } from 'vuelidate/lib/validators'
import useSubscriptionsList from './useSubscriptionsList'

export default {
  name: 'SubscriptionEdit',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BRow,
    LayoutLoading,
  },
  directives: {
    Ripple,
  },
  validations() {
    return {
      form: {
        email: { required, minLength: minLength(3) },
      },
    }
  },

  setup() {
    const {
      convertResource,
      fetchItem,
      form,
      handleUpload,
      isSubmit,
      item,
      itemLoading,
      updateItem,
    } = useSubscriptionsList()

    return {
      convertResource,
      fetchItem,
      form,
      handleUpload,
      isSubmit,
      item,
      itemLoading,
      updateItem,
    }
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchItem(this.itemId)
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      const data = { email: this.form.email }
      this.updateItem(this.itemId, data, this.form.lang)
    },
  },
}
</script>
